import { prop } from "ramda";
import { createSelector } from "reselect";
import { STATE_IDENTIFIER } from "./constants";

const {
  CALL_STATE,
  PWD_POLICY,
  TEMP_TOKEN,
  TEMP_TOKEN_TYPE,
  UIGP_OTP_RECEIVER,
  AUTH_RESPONSE_ERROR,
} = STATE_IDENTIFIER;

const twoFactorState = (state: any) => state.twoFactorState;

export const selectTempToken: any = createSelector(
  twoFactorState,
  prop(TEMP_TOKEN)
);
export const selectTempTokenType: any = createSelector(
  twoFactorState,
  prop(TEMP_TOKEN_TYPE)
);
export const selectPwdPolicy: any = createSelector(
  twoFactorState,
  prop(PWD_POLICY)
);
export const selectCallState: any = createSelector(
  twoFactorState,
  prop(CALL_STATE)
);

export const selectUigpOtpReceiver: any = createSelector(
  twoFactorState,
  prop(UIGP_OTP_RECEIVER)
);

export const selectAuthResponseError: any = createSelector(
  twoFactorState,
  prop(AUTH_RESPONSE_ERROR)
);
